import { Button, ButtonProps, IconEdit } from '@cmpsr/components';

export default function EditEmailAddressAction({ onClick }: ButtonProps) {
  return (
    <Button
      onClick={onClick}
      size="s"
      trailingIcon={<IconEdit />}
      variant="link-secondary"
      alignSelf={{ base: 'flex-start', lg: 'center' }}
    >
      Edit Email Address
    </Button>
  );
}
